module.exports = __webpack_public_path__ + "static/media/Warsaw Skitterphoto.bd843437.jpg";